import { Component, EventEmitter, Input, Output } from '@angular/core';
import { downloadIcon, SVGIcon } from '@progress/kendo-svg-icons';
import { FileManagementService } from '../../../../shared/services/file-management.service';
import { DocumentService } from '../../services/document.service';
import { AssignedDocument } from '../../models/assigned-document';
import { CertificateService } from '../../services/certificate.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { StringConstants } from '@app/shared/string-constants';
import { TaskNotification } from '../../models/task-notification';

@Component({
	selector: 'kpa-document',
	templateUrl: './document.component.html',
	styleUrls: ['./document.component.scss'],
})
export class DocumentComponent {
	@Input() dialogOpened: boolean = false;
	@Input() documentTitle: string;
	@Input() documentId: string;
	@Output() dialogOpenedChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() closeDialog = new EventEmitter();
	@Output() onTaskComplete: EventEmitter<TaskNotification> = new EventEmitter<TaskNotification>();
	isReadDocEnabled: boolean = false;
	showErrorMsg: boolean = false;
	constructor(
		private fileManagementService: FileManagementService,
		private documentService: DocumentService,
		private certificateService: CertificateService,
		private notificationService: NotificationService
	) {}

	public downloadIcon: SVGIcon = downloadIcon;
	public open(component: string): void {
		this[component + 'Opened'] = true;
	}

	public completeTraining(documentId: string) {
		if (!this.isReadDocEnabled) {
			this.showErrorMsg = true;
			return;
		}
		this.documentService.completeTraining(documentId).subscribe((result: AssignedDocument) => {
			if (result) {
				const taskNotification: TaskNotification = {
					isCompleted: true,
					isReviewed: false,
				};
				this.dialogOpenedChange.emit();
				this.onTaskComplete.emit(taskNotification);
				this.dialogOpened = false;
				this.isReadDocEnabled = false;
				this.showErrorMsg = false;
			}
		});
	}

	public downloadFileByDocId(documentId) {
		if (documentId) {
			this.fileManagementService.downloadFileByDocId(documentId).subscribe({
				next: (response) => {
					this.certificateService.downloadCert(this.documentTitle, response);
					this.isReadDocEnabled = true;
					this.showErrorMsg = false;
				},
				error: (err) => {
					this.notificationService.show({
						content: 'Error while downloading document.',
						hideAfter: StringConstants.hideNotificationAfter,
						position: { horizontal: 'right', vertical: 'bottom' },
						animation: { type: 'fade', duration: 400 },
						type: { style: 'error', icon: true },
					});
				},
			});
		}
	}

	public close(component: string): void {
		this[component + 'Opened'] = false;
		this.isReadDocEnabled = false;
		this.showErrorMsg = false;
		this.closeDialog.emit();
	}
}
